import { BaseOperationModel } from '../base-operation-model';

export class MicrosoftOfficeAuditResourcesModel extends BaseOperationModel {
  beginDate: Date;
  endDate: Date;
  providerPolicy: string;
}
